import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';
import {PipesModule} from 'shared/pipes/pipes.module';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {DialogsOverviewRoutingModule} from './dialogs-overview-routing.module';
import {DialogsOverviewComponent} from './dialogs-overview.component';
import {DialogsOverviewRepository} from './repositories/dialogs-overview.repository';
import {DialogsOverviewService} from './services/dialogs-overview.service';

@NgModule({
  imports: [
    CommonModule,
    DialogsOverviewRoutingModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ModalConfirmationModule,
    SearchBarModule,
    PipesModule,
  ],
  declarations: [
    DialogsOverviewComponent,
  ],
  providers: [
    DialogsOverviewService,
    DialogsOverviewRepository,
    SearchBarComponent,
  ],
})
export class DialogsOverviewModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dialogs/dialogs-overview/dialogs-overview.module.ts